export const VALUES = 'VALUES';
export const EVERY = 'EVERY';
export const EVERY_N = 'EVERY_N';
export const ON_LAST_DAY = 'ON_LAST_DAY';
export const ON_NTH_WEEKDAY = 'ON_NTH_WEEKDAY';
export const NOT_APPLICABLE = 'NOT_APPLICABLE';
export const FIRST_MONDAY = 'FIRST_MONDAY';
export const DELEGATE_TO_PROPERTY_VALUE = 'DELEGATE_TO_PROPERTY_VALUE';
export const ExpressionTypes = {
  VALUES,
  EVERY,
  EVERY_N,
  ON_LAST_DAY,
  ON_NTH_WEEKDAY,
  NOT_APPLICABLE,
  FIRST_MONDAY,
  DELEGATE_TO_PROPERTY_VALUE
};
export default ExpressionTypes;